<template>
  <div
    class="bio text-2xl leading-normal sm:p-4 sm:text-4xl md:p-8 xl:text-6xl"
    :class="classObj"
  >
    <header class="inline">
      <h1 class="inline">
        Spencer Madsen
        <img src="@/assets/images/stick-guy.svg" alt="" />
      </h1>
      (b. 1992)
    </header>
    <bio-line
      v-for="(line, i) in text"
      :key="`line-${i}`"
      :expanded="true"
      v-bind="line"
    />.
  </div>
</template>

<script>
import imagesLoaded from 'imagesloaded'
import BioLine from '@/components/BioLine.vue'

export default {
  name: 'Bio',

  components: {
    BioLine
  },

  props: {
    text: {
      default: () => [],
      type: Array
    }
  },

  data: () => ({
    imagesLoaded: false,
    textLoaded: false
  }),

  watch: {
    text(lines) {
      if (lines.length) {
        this.textLoaded = true
      }
    }
  },

  computed: {
    classObj() {
      return {
        'is-loaded': this.imagesLoaded && this.textLoaded
      }
    }
  },

  mounted() {
    if (this.text.length) {
      this.textLoaded = true
    }
    imagesLoaded(this.$el, () => {
      setTimeout(() => {
        this.imagesLoaded = true
      }, 300)
    })
  }
}
</script>

<style>
.bio {
  --image-height: 1em;
  --image-gutter: 0.25em;
  opacity: 0;
  transition: opacity 0.25s;
  will-change: opacity;
}

.bio.is-loaded {
  opacity: 1;
}

.bio img {
  display: inline-block;
  height: var(--image-height);
  vertical-align: middle;
  width: auto;
}
</style>
